module.exports = __webpack_public_path__ + "1377f41900f5f673eeccccbb7c39edf6.jpg";